var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCa = function SvgCa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#CA_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 42c11.598 0 21-9.402 21-21S32.598 0 21 0 0 9.402 0 21s9.402 21 21 21Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.002 21.002c0-8.326-4.846-15.52-11.87-18.916v37.832c7.024-3.397 11.87-10.59 11.87-18.916ZM.001 21c0 8.326 4.845 15.52 11.87 18.917V2.084C4.846 5.481 0 12.675 0 21.001ZM24.653 23.74l3.652-1.825-1.826-.913v-1.826l-3.652 1.826 1.826-3.652h-1.826l-1.826-2.74-1.826 2.74h-1.826l1.826 3.652-3.652-1.826v1.826l-1.826.913 3.652 1.826-.913 1.826h3.652v2.74h1.826v-2.74h3.652l-.913-1.826Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "CA_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h42v42H0z"
  })))));
};
export default SvgCa;